import { Cancel, Delete, Save } from '@material-ui/icons';
import React, { useState } from 'react';
import CustomDraggableDialog from '../customDialog/CustomDraggableDialog';
import CustomButton from './CustomButton';
import RightButtonArea from './RightButtonArea';
import TranslatedMessage from '../../translations/TranslatedMessage';

interface DefaultButtonsProps {
  isDeleteButtonEnabled?: boolean;
  isSaveButtonEnabled?: boolean;
  isCloseButtonEnabled?: boolean;
  isDeleteButtonVisible?: boolean;
  isSaveButtonVisible?: boolean;
  isCloseButtonVisible?: boolean;
  onDelete?: () => void;
  onSave?: () => void;
  onClose?: () => void;
  additionalButtons?: "" | JSX.Element;
}

const DefaultButtons: React.FunctionComponent<DefaultButtonsProps> = (props) => {
  const [isDeleteDialogOpen, showDeleteDialog] = useState(false);

  const deleteButton = props.isDeleteButtonVisible ?
    <CustomButton tooltip={<TranslatedMessage id="common.delete" />} onClick={() => showDeleteDialog(true)} disabled={!props.isDeleteButtonEnabled} >
      <Delete />
    </CustomButton>
    : <React.Fragment />;

  const saveButton = props.isSaveButtonVisible ?
    <CustomButton tooltip={<TranslatedMessage id="common.save" />} onClick={props.onSave!} disabled={!props.isSaveButtonEnabled}>
      <Save />
    </CustomButton>
    : <React.Fragment />;

  const closeButton = props.isCloseButtonVisible ?
    <CustomButton tooltip={<TranslatedMessage id="common.close" />} onClick={props.onClose!} disabled={!props.isCloseButtonEnabled}>
      <Cancel />
    </CustomButton>
    : <React.Fragment />;

  return (
    <React.Fragment>
      <RightButtonArea>
        {props.additionalButtons}
        {deleteButton}
        {saveButton}
        {closeButton}
      </RightButtonArea>
      <CustomDraggableDialog
        acceptText={<TranslatedMessage id="common.accept" />}
        cancelText={<TranslatedMessage id="common.cancel" />}
        content={<TranslatedMessage id="common.confirmDeleteDescription" />}
        isOpen={isDeleteDialogOpen}
        onAccept={props.onDelete!}
        onCancel={() => showDeleteDialog(false)}
        title={<TranslatedMessage id="common.attention" />} />
    </React.Fragment>
  );
}

DefaultButtons.defaultProps = {
  isDeleteButtonEnabled: true,
  isSaveButtonEnabled: true,
  isCloseButtonEnabled: true,
  isDeleteButtonVisible: true,
  isSaveButtonVisible: true,
  isCloseButtonVisible: true,
  onDelete: () => { },
  onSave: () => { },
  onClose: () => { },
} as Partial<DefaultButtonsProps>;

export default DefaultButtons;
